import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';

function Laverage(props) {
    return (
        <div className="laverage_section laverage_wearable p-100" style={{ backgroundColor: "#FCFCFC" }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Wearable App Development Services For All Wearable Devices</h2>
                        <p>If you think that wearables just include smart watches, you surely are missing out on things. Wearables are now the hottest thing in the industry, spanning an entire ecosystem of devices that users interact with on a daily basis. As wearable app development company, we cater to all of these devices to ensure that your app is present on all such devices.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Eyewear</h6>
                                <p>This is what we like to call the “handsfree” world. Based on visual overlay combine with stunning design and graphics, Tekrevol can build a wearable app for all types of eyewear devices out there.</p>
                                <ul>
                                    <li>Smart Glasses</li>
                                    <li>Light Emit Glasses</li>
                                    <li>VR/AR Headsets</li>
                                </ul>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>The Healthcare Segment</h6>
                                <p>Wearables are now revolutionizing healthcare with their in-time patient monitoring systems. Through Android wearable app development, you can easily help your patients track any aspect related to their vitals and relay important reports back to you for timely monitoring.</p>
                                <ul>
                                    <li>Heart Rate Monitors</li>
                                    <li>Vitals Monitoring</li>
                                    <li>Appointment & Prescription Reminder Apps</li>
                                </ul>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Wristwear</h6>
                                <p>Utilizing the latest tech in sensor based monitoring, Tekrevol is a top rated wearable app development company that builds apps which can help anyone with tracking their movements in real time.</p>
                                <ul>
                                    <li>Sleep Monitoring Apps</li>
                                    <li>Fitness Trackers</li>
                                    <li>Activity/Time/Lap Monitor Apps</li>
                                </ul>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Smart Watch Segment</h6>
                                <p>Smart Watches are incredibly helpful in helping users optimize their fitness and exercise regimens. And since we can do both, Android wearable app development and Apple watch app development, your app will be able to function on all types of smart watches seamlessly.</p>
                                <ul>
                                    <li>Sports Watches</li>
                                    <li>iWatch App Development</li>
                                    <li>Android wearable apps</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;